import { Injectable } from '@angular/core';
import { IApi, GenericApi } from '../../common/ng-api';
import { Message } from '../../models/send-it/message';
import { Http, Headers } from '@angular/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';

@Injectable()
export class SentItMessageService {

  constructor(private http: Http) {

  }

  public makeHeader(token) {
    const headers = new Headers();

    headers.append('x-google-captcha', token);
    headers.append('x-tenant-code', 'aqua');
    headers.append('Content-Type', 'application/json')

    return { headers: headers };

  }

  send(token: string, model: any) {
    const url = `${environment.apiUrls.sendIt}/api/messages/byCaptcha`
    console.log('sending request to url: ', url);
    return this.http.post(url, model, this.makeHeader(token))
      .map((result) => result.json())
      .catch(this.handleError)
  }

  private handleError(error: any) {

    return Observable.throw(error || 'Server error');

  }
}



// WEBPACK FOOTER //
// /opt/build/repo/src/app/services/send-it/sent-it-message.service.ts